import { Link, usePage } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { Card, CardContent } from "@/components/ui/Card"
import MarketFlag from "@/components/layout/MarketFlag"
import type { Market } from "@/lib/useMarket"
import { market_switch_path } from "@/lib/routes"

type Props = { to: string; org_markets?: Market[] }

// Where a Menu market link lands when no market is remembered yet. Picking
// a market is a deliberate switch: it is saved, so the next market link goes
// straight there.
export default function MarketPickerShow() {
  const { to, org_markets } = usePage<Props>().props
  const markets = org_markets ?? []

  return (
    <AppLayout header={<PageTitle title="Which market?" subtitle="Pick a market. You can switch any time from the top bar." />}>
      <Card className="max-w-md">
        <CardContent className="flex flex-col gap-2 p-4">
          {markets.length === 0 ? (
            <p className="text-sm text-foreground">Your org has no markets yet. Add a country in Org Structure.</p>
          ) : (
            markets.map((m) => (
              <Link
                key={m.id}
                href={market_switch_path()}
                method="post"
                data={{ market: m.slug, to: `/m/${m.slug}${to}` }}
                as="button"
                className="flex items-center gap-3 rounded-md border border-border px-4 py-3 text-left text-sm font-medium text-foreground transition-colors hover:bg-muted"
              >
                <MarketFlag market={m} />
                {m.name}
                <span className="ml-auto text-xs text-muted-foreground">{m.currency}</span>
              </Link>
            ))
          )}
        </CardContent>
      </Card>
    </AppLayout>
  )
}
